import React, { FunctionComponent } from 'react';
import { FlashBox } from '../../atoms/flashBox';
import { RecruitmentRegisterModal } from '../../organisms/recruitmentRegisterModal';
import { RecruitmentShowHeading } from '../../organisms/recruitmentShowHeading';
import { RecruitmentShowContent } from '../../organisms/recruitmentShowContent';
import { RecruitmentShowBottom } from '../../organisms/recruitmentShowBottom';
import { RecruitmentShowProps, RecruitmentShowState } from './types';
import { RecruitmentConnectModal } from '../../molecules/recruitmentConnectModal';
import classnames from 'classnames';
import { RecruitmentConnectedModal } from '../../molecules/recruitmentConnectedModal';
import { LoginModal } from '../../organisms/loginModal';

type Props = RecruitmentShowProps & {
  state: RecruitmentShowState;
  isConnectModalOpen: boolean;
  isConnectCompleteModalOpen: boolean;
  interest: 'want_to_work' | 'want_to_hear' | 'interesting';
  isConnected: boolean;
  connectMessageBoxId: number | null;
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  isSubmitting: boolean;
  handleToggleLoginModal: () => void;
  handleChangeModal: (from: "login" | "register") => void;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
  handleRegisterModalOpen: () => void;
  handleSwitchLoginModalOpen: () => void;
  handleConnectModalOpen: () => void;
  handleClickEntry: () => void;
  handleClickModalBg: () => void;
  handleSubmitConnect: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleChangeInterest: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePreviewClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  handleIsLogin: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  lineIcon,
  noimage,
  noIconImg,
  recruitmentId,
  userId,
  company,
  isUser,
  user,
  currentUser,
  isCompany,
  connectedFlag,
  isScouted,
  isStopped,
  isShow,
  isPreview = false,
  messageBoxId,
  redirectUrl,
  occupations,
  preferredOccupations,
  occupationDetails,
  graduationArray,
  graduationAnnotaion,
  prefectures,
  occupationUrl,
  occupationName,
  industryUrl,
  title,
  instagramIcon,
  hoverIcon,
  isStudentAndMidCareer,
  relatedRecruitments,
  hasRequiredProfiles,
  needProfileUpdate,
  requiredProfileNames,
  isLoginError,
  modalFlashMessage,
  mags,
  isShowMag,
  isShowToggleInRecruitmentShowPage = false,
  isStoppedFv,
  hideTopEntryButton = false,
  profileImmediateInputFlag,
  enforceFlag,
  birthdayList,
  startYearList,
  endYearList,
  careerEmploymentTypes,
  state,
  isConnectModalOpen,
  isConnectCompleteModalOpen,
  interest,
  isConnected,
  connectMessageBoxId,
  isLoginModalOpen,
  isRegisterModalOpen,
  isSubmitting,
  handleToggleLoginModal,
  handleChangeModal,
  handleFlash,
  handleRegisterModalOpen,
  handleSwitchLoginModalOpen,
  handleConnectModalOpen,
  handleClickEntry,
  handleClickModalBg,
  handleSubmitConnect,
  handleChangeInterest,
  handlePreviewClick,
  handleIsLogin,
}) => {
  return (
    <main className="recruitment__show js-l-single-main">
      <FlashBox
        flash={state.flash}
        flashType={state.flashType}
        flashMessage={state.flashMessage}
        handleFlash={handleFlash}
      />

      <RecruitmentRegisterModal
        recruitmentId={recruitmentId}
        companyId={company.id}
        occupations={occupations}
        preferredOccupations={preferredOccupations}
        occupationDetails={occupationDetails}
        prefectures={prefectures}
        handleRegisterModalOpen={handleRegisterModalOpen}
        handleSwitchLoginModalOpen={handleSwitchLoginModalOpen}
        handleConnectModalOpen={handleConnectModalOpen}
        handleIsLogin={handleIsLogin}
        graduationArray={graduationArray}
        graduationAnnotaion={graduationAnnotaion}
        isRegisterOpenModal={isRegisterModalOpen}
        redirectUrl={redirectUrl}
        handleFlash={handleFlash}
        lineIcon={lineIcon}
        dataCategory={state.dataCategoryRecruitmentRegisterModal}
        dataValue={state.dataValueRecruitmentRegisterModal}
        isStoppedFv={isStoppedFv}
      />
      <LoginModal
        isModalOpen={isLoginModalOpen}
        redirectUrl={redirectUrl}
        fromButton="recruitment"
        recruitmentId={recruitmentId}
        isLoginError={isLoginError}
        flashMessage={modalFlashMessage}
        handleToggleLoginModal={handleToggleLoginModal}
        handleChangeModal={handleChangeModal}
        lineIcon={lineIcon}
      />

      {(!isStoppedFv || !isStopped) && (
        <RecruitmentShowHeading recruitmentId={recruitmentId} noimage={noimage} />
      )}

      <RecruitmentShowContent
        recruitmentId={recruitmentId}
        companyId={company.id}
        messageBoxId={connectMessageBoxId}
        noimage={noimage}
        noIconImg={noIconImg}
        currentUser={currentUser}
        isLoggedIn={state.isLogin}
        isCompany={isCompany}
        connectedFlag={isConnected}
        isScouted={isScouted}
        isStopped={isStopped}
        isShow={isShow}
        isUser={isUser}
        user={user}
        occupationUrl={occupationUrl}
        occupationName={occupationName}
        industryUrl={industryUrl}
        dataCategory={state.dataCategory}
        dataValue={state.dataValueRecruitmentShowContent}
        handleRegisterModalOpen={handleRegisterModalOpen}
        handleClickEntry={handleClickEntry}
        isPreview={isPreview}
        handlePreviewClick={handlePreviewClick}
        lineIcon={lineIcon}
        mags={mags}
        isShowMag={isShowMag}
        isShowToggleInRecruitmentShowPage={isShowToggleInRecruitmentShowPage}
        isStoppedFv={isStoppedFv}
        hideTopEntryButton={hideTopEntryButton}
      />

      <RecruitmentShowBottom
        recruitmentId={recruitmentId}
        companyId={company.id}
        noimage={noimage}
        isUser={isUser}
        isStopped={isStopped}
        noIconImg={noIconImg}
        dataCategory={state.dataCategory}
        dataValue={state.dataValueRecruitmentShowBottom}
        isCompany={isCompany}
        connectedFlag={isConnected}
        isScouted={isScouted}
        messageBoxId={connectMessageBoxId}
        isShowMag={isShowMag}
        hideTopEntryButton={hideTopEntryButton}
        handleRegisterModalOpen={handleRegisterModalOpen}
        handleClickEntry={handleClickEntry}
        isPreview={isPreview}
        handlePreviewClick={handlePreviewClick}
      />

      <div
        className={classnames( 'l-modal bg', { 'is-active': isConnectModalOpen} )}
        onClick={handleClickModalBg}
      >
        <RecruitmentConnectModal
          interest={interest}
          isConnectModalOpen={isConnectModalOpen}
          isConnectCompleteModalOpen={isConnectCompleteModalOpen}
          isLoggedIn={state.isLogin || isUser || isCompany}
          isPerson={isUser}
          isScouted={isScouted}
          showMidCareerWarning={isStudentAndMidCareer ?? false}
          companyId={company.id}
          recruitmentId={recruitmentId}
          isSubmitting={isSubmitting}
          handleSubmitConnect={handleSubmitConnect}
          handleChangeInterest={handleChangeInterest}
        />
      </div>
      <RecruitmentConnectedModal
        isConnectCompleteModalOpen={isConnectCompleteModalOpen}
        recruitmentId={recruitmentId}
        personId={userId}
        isLoggedIn={state.isLogin || isUser || isCompany}
        isCompany={isCompany}
        hasRequiredProfiles={hasRequiredProfiles}
        needProfileUpdate={needProfileUpdate}
        requiredProfileNames={requiredProfileNames}
        relatedRecruitments={relatedRecruitments}
        companyName={company.name}
        handleClickModalBg={handleClickModalBg}
        profileImmediateInputFlag={profileImmediateInputFlag}
        enforceFlag={enforceFlag}
        birthdayList={birthdayList}
        startYearList={startYearList}
        endYearList={endYearList}
        careerEmploymentTypes={careerEmploymentTypes}
      />
    </main>
  );
};
